const labels = {
  product_unavailable: ["This product is no longer available", "هذا المنتج لم يعد متاحًا"],
  category_unavailable: ["This product’s category is no longer available", "قسم هذا المنتج لم يعد متاحًا"],
  product_purchase_disabled: ["Ordering this product has been disabled", "تم إيقاف طلب هذا المنتج"],
  not_available: ["Not available for these order options", "غير متاح لخيارات الطلب الحالية"],
  not_available_in_branch: ["Not available at the selected branch", "غير متاح في الفرع المختار"],
  scheduled_availability_unavailable: ["Not available at the selected time", "غير متاح في الوقت المختار"],
  required_extra_field_missing: ["Edit this item to complete its required details", "عدّل المنتج لإكمال البيانات المطلوبة"],
  variant_required: ["Edit this item to choose a variant", "عدّل المنتج لاختيار النوع"],
  option_unavailable: ["Edit this item to choose available options", "عدّل المنتج لاختيار خيارات متاحة"],
  out_of_stock: ["Out of stock for this location", "غير متوفر في هذا الموقع"],
  branch_unavailable: ["Not sold by the selected branch", "غير متوفر في الفرع المحدد"],
  delivery_only: ["Available for delivery only", "متوفر للتوصيل فقط"],
  pickup_only: ["Available for pickup only", "متوفر للاستلام فقط"],
  maximum_quantity_unavailable: ["The requested quantity is unavailable", "الكمية المطلوبة غير متوفرة"],
};

export const getCartReasonLabel = (reason, language = "english") => {
  const code = `${reason || ""}`.trim();
  if (!code) return "";
  return labels[code]?.[language === "arabic" ? 1 : 0] ||
    code.replace(/_/g, " ").replace(/^./, letter => letter.toUpperCase());
};
